module.exports = __webpack_public_path__ + "img/locks.288fec4f.jpg";